//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'rb-message-box',
  props: {
    type: {
      type: String,
      default: 'success',
    },
  },
  computed: {
    getMessageBoxStyle() {
      return `rb-message--${this.type}`
    },
  },
}
